/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  MissingPositionDTO,
  PositionSuggestionDTO,
  SavePositionsRequestDTO,
  SavePositionsResultDTO,
  SuggestPositionsRequestDTO,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useRoutePlanningSettingsGetMissingPositionsHook = () => {
  const routePlanningSettingsGetMissingPositions =
    useCustomInstance<MissingPositionDTO[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return routePlanningSettingsGetMissingPositions({
        url: `/api/RoutePlanningSettings/GetMissingPositions`,
        method: 'GET',
        signal,
      });
    },
    [routePlanningSettingsGetMissingPositions]
  );
};

export const getRoutePlanningSettingsGetMissingPositionsQueryKey = () => {
  return [`/api/RoutePlanningSettings/GetMissingPositions`] as const;
};

export const useRoutePlanningSettingsGetMissingPositionsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useRoutePlanningSettingsGetMissingPositionsHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useRoutePlanningSettingsGetMissingPositionsHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRoutePlanningSettingsGetMissingPositionsQueryKey();

  const routePlanningSettingsGetMissingPositions =
    useRoutePlanningSettingsGetMissingPositionsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useRoutePlanningSettingsGetMissingPositionsHook>
      >
    >
  > = ({ signal }) => routePlanningSettingsGetMissingPositions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useRoutePlanningSettingsGetMissingPositionsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RoutePlanningSettingsGetMissingPositionsQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useRoutePlanningSettingsGetMissingPositionsHook>
    >
  >
>;
export type RoutePlanningSettingsGetMissingPositionsQueryError = unknown;

export const useRoutePlanningSettingsGetMissingPositions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useRoutePlanningSettingsGetMissingPositionsHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useRoutePlanningSettingsGetMissingPositionsHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useRoutePlanningSettingsGetMissingPositionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useRoutePlanningSettingsSuggestPositionsHook = () => {
  const routePlanningSettingsSuggestPositions =
    useCustomInstance<PositionSuggestionDTO[]>();

  return useCallback(
    (suggestPositionsRequestDTO: SuggestPositionsRequestDTO) => {
      return routePlanningSettingsSuggestPositions({
        url: `/api/RoutePlanningSettings/SuggestPositions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: suggestPositionsRequestDTO,
      });
    },
    [routePlanningSettingsSuggestPositions]
  );
};

export const useRoutePlanningSettingsSuggestPositionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useRoutePlanningSettingsSuggestPositionsHook>
      >
    >,
    TError,
    { data: SuggestPositionsRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useRoutePlanningSettingsSuggestPositionsHook>>
  >,
  TError,
  { data: SuggestPositionsRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanningSettingsSuggestPositions =
    useRoutePlanningSettingsSuggestPositionsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useRoutePlanningSettingsSuggestPositionsHook>
      >
    >,
    { data: SuggestPositionsRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanningSettingsSuggestPositions(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanningSettingsSuggestPositionsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useRoutePlanningSettingsSuggestPositionsHook>>
  >
>;
export type RoutePlanningSettingsSuggestPositionsMutationBody =
  SuggestPositionsRequestDTO;
export type RoutePlanningSettingsSuggestPositionsMutationError = unknown;

export const useRoutePlanningSettingsSuggestPositions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useRoutePlanningSettingsSuggestPositionsHook>
      >
    >,
    TError,
    { data: SuggestPositionsRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useRoutePlanningSettingsSuggestPositionsHook>>
  >,
  TError,
  { data: SuggestPositionsRequestDTO },
  TContext
> => {
  const mutationOptions =
    useRoutePlanningSettingsSuggestPositionsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useRoutePlanningSettingsSavePositionsHook = () => {
  const routePlanningSettingsSavePositions =
    useCustomInstance<SavePositionsResultDTO>();

  return useCallback(
    (savePositionsRequestDTO: SavePositionsRequestDTO) => {
      return routePlanningSettingsSavePositions({
        url: `/api/RoutePlanningSettings/SavePositions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: savePositionsRequestDTO,
      });
    },
    [routePlanningSettingsSavePositions]
  );
};

export const useRoutePlanningSettingsSavePositionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanningSettingsSavePositionsHook>>
    >,
    TError,
    { data: SavePositionsRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useRoutePlanningSettingsSavePositionsHook>>
  >,
  TError,
  { data: SavePositionsRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanningSettingsSavePositions =
    useRoutePlanningSettingsSavePositionsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanningSettingsSavePositionsHook>>
    >,
    { data: SavePositionsRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanningSettingsSavePositions(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanningSettingsSavePositionsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useRoutePlanningSettingsSavePositionsHook>>
  >
>;
export type RoutePlanningSettingsSavePositionsMutationBody =
  SavePositionsRequestDTO;
export type RoutePlanningSettingsSavePositionsMutationError = unknown;

export const useRoutePlanningSettingsSavePositions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanningSettingsSavePositionsHook>>
    >,
    TError,
    { data: SavePositionsRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useRoutePlanningSettingsSavePositionsHook>>
  >,
  TError,
  { data: SavePositionsRequestDTO },
  TContext
> => {
  const mutationOptions =
    useRoutePlanningSettingsSavePositionsMutationOptions(options);

  return useMutation(mutationOptions);
};
